import React from 'react';

const menuItemGroup = (props) => {
    return (
        <div>
            <div className='row submenu'>
                {props.children}
            </div>
        </div>
    )
}

export default menuItemGroup



// WEBPACK FOOTER //
// ./src/Search/Menu/MenuGroup/MenuGroup.js